import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';

interface MaintenanceWarningOverlayProps {
  warningStartedAt: string;
}

export function MaintenanceWarningOverlay({ warningStartedAt }: MaintenanceWarningOverlayProps) {
  const [timeRemaining, setTimeRemaining] = useState<number>(0);

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const warningStart = new Date(warningStartedAt);
      const maintenanceStart = new Date(warningStart.getTime() + 5 * 60 * 1000);
      const now = new Date();
      const remaining = Math.max(0, Math.floor((maintenanceStart.getTime() - now.getTime()) / 1000));
      setTimeRemaining(remaining);
    };

    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, [warningStartedAt]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 animate-pulse">
      <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white px-6 py-4 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-4">
          <AlertTriangle className="w-6 h-6 animate-bounce" />
          <div className="flex-1 text-center">
            <p className="font-bold text-lg">
              Scheduled Maintenance Starting Soon
            </p>
            <p className="text-sm mt-1">
              Please save your work. Maintenance begins in{' '}
              <span className="font-mono font-bold text-xl">
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
              </span>
            </p>
          </div>
          <AlertTriangle className="w-6 h-6 animate-bounce" />
        </div>
      </div>

      <div className="relative h-1 bg-gray-200 overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-amber-400 to-orange-600 transition-all duration-1000 ease-linear"
          style={{ width: `${(timeRemaining / 300) * 100}%` }}
        />
      </div>
    </div>
  );
}